import { useMemo } from 'react';
import type {
  FormSegment,
  GroupLike,
  LookalikeFormSegment,
} from '../../../../../../../../modules/audiences/AudienceForm/types.ts';
import { getDirectAndFirstPartySegments } from '../../../utils/getDirectAndFirstPartySegments.ts';
import { getPredefinedSegments } from '../../../utils/getPredefinedSegments.ts';
import { isGroup } from '../../utils/guards.ts';

type UseGetSegmentsValuesProps = {
  segmentsGroup: GroupLike;
};

type SegmentsResult = {
  directSegments: FormSegment[];
  rtgSegments: FormSegment[];
  thirdPartySegments: FormSegment[];
  siteCategorySegments: FormSegment[];
  oxPurchaseSegments: FormSegment[];
  lookalikeSegments: LookalikeFormSegment[];
};

export const useGetSegmentsValues = ({ segmentsGroup }: UseGetSegmentsValuesProps): SegmentsResult => {
  const { directSegmentValues } = useMemo(() => {
    return getDirectAndFirstPartySegments(isGroup(segmentsGroup) ? (segmentsGroup.direct?.segments ?? []) : []);
  }, [segmentsGroup]);

  const predefinedSegments = useMemo(
    () => getPredefinedSegments(isGroup(segmentsGroup) ? (segmentsGroup.predefined?.segments ?? []) : []),
    [segmentsGroup]
  );

  const currentLookalikeSegments = useMemo(() => {
    return isGroup(segmentsGroup) ? (segmentsGroup.lookalike?.segments ?? []) : [];
  }, [segmentsGroup]);

  return {
    directSegments: directSegmentValues,
    rtgSegments: predefinedSegments.rtgSegments,
    thirdPartySegments: predefinedSegments.thirdPartySegments,
    siteCategorySegments: predefinedSegments.siteCategorySegments,
    oxPurchaseSegments: predefinedSegments.oxPurchaseSegments,
    lookalikeSegments: currentLookalikeSegments,
  };
};
